/**
 * Main
 *
 * The main file, page logic which is needed on all pages will be included here.
 * Please note for specific components like a slider create a separated components/<component_name>.js
 * The components will be loaded through the component loader and are not needed on every page!
 */
import MmenuLight from 'mmenu-light';
document.addEventListener('DOMContentLoaded', () => {
  const menuHolder = document.querySelector('#nav');

  if (menuHolder) {
    const menu = new MmenuLight(menuHolder, '(max-width: 992px)');
    menu.navigation({
      selected: 'is-active',
      title: 'Menu',
      theme: 'dark'
    });
    const drawer = menu.offcanvas({
      position: 'left'
    });
    document.querySelector('a[href="#nav"]').addEventListener('click', event => {
      event.preventDefault();
      drawer.open();
    });
  }

  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      $('.header').addClass('is-sticky');
    } else {
      $('.header').removeClass('is-sticky');
    }
  });
});